import React from 'react';
import { capitalize } from '../../utilities/strings';
const FieldCell = (props) => {
    return (React.createElement("div", null, capitalize(Object.keys(props.value)[0])));
};
export default FieldCell;
//# sourceMappingURL=FieldCell.js.map